import { p } from './core.js'

// Categoria 3b — Cômodas + Sapateiras + Baús (R3)
// SKUs: CM-A..F (6), SAP-A..I (9), BAU-A..D (4) = 19 modelos
//
// Cômodas: tampo/base/laterais externas/frentes de gaveta → cor.
//          Traseiras/laterais de gaveta, divisórias internas, prateleira atrás
//          de porta (CM-D) → branco.
// Sapateiras G/H/I: tampo, porta basculante e laterais em 25mm.
// Baús: peças expostas (tampa, frente, traseira, laterais) → cor.
//       Base e divisória interna → branco.
//
// Moldura 6mm (CM-C, CM-F): largura padrão 0.05m (5cm). Como o helper sempre usa
// preço 6mm branco, a moldura é precificada em 6mm independente da cor — manter
// consistente com o resto do catálogo.

const L_MOLDURA = 0.05

export const COMODAS_SAPATEIRAS_BAUS = {

  // ── CM-A — Cômoda 4 Gavetas Básica ──────────────────────────────────────────
  'Cômoda 4 Gavetas': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',           '15', v => v.P * v.A, 2),
      p('Tampo',             '15', v => v.C * v.P, 1),
      p('Base',              '15', v => v.C * v.P, 1, 'branco'),
      p('Frente gaveta',     '15', v => v.C * 0.20, 4),
      p('Traseira gaveta',   '15', v => v.C * 0.20, 4, 'branco'),
      p('Lateral gaveta',    '15', v => v.P * 0.20, 8, 'branco'),
      p('Fundo do móvel',    '6',  v => v.C * v.A, 1),
      p('Fundo de gaveta',   '6',  v => v.C * v.P, 4),
    ],
    ferragens: { dobradica: 0, corredica: 4, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── CM-B — Cômoda 5 Gavetas ─────────────────────────────────────────────────
  'Cômoda 5 Gavetas': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',           '15', v => v.P * v.A, 2),
      p('Tampo',             '15', v => v.C * v.P, 1),
      p('Base',              '15', v => v.C * v.P, 1, 'branco'),
      p('Frente gaveta',     '15', v => v.C * 0.20, 5),
      p('Traseira gaveta',   '15', v => v.C * 0.20, 5, 'branco'),
      p('Lateral gaveta',    '15', v => v.P * 0.20, 10, 'branco'),
      p('Fundo do móvel',    '6',  v => v.C * v.A, 1),
      p('Fundo de gaveta',   '6',  v => v.C * v.P, 5),
    ],
    ferragens: { dobradica: 0, corredica: 5, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── CM-D — Cômoda 5 Gavetas + 1 Porta de Giro Lateral ───────────────────────
  // C_porta = C/3 (default).
  'Cômoda 5 Gavetas com Porta': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',                  '15', v => v.P * v.A, 2),
      p('Tampo',                    '15', v => v.C * v.P, 1),
      p('Base',                     '15', v => v.C * v.P, 1, 'branco'),
      p('Divisória vertical',       '15', v => v.P * v.A, 1, 'branco'),
      p('Frente gaveta',            '15', v => (v.C - v.C/3) * 0.20, 5),
      p('Traseira gaveta',          '15', v => (v.C - v.C/3) * 0.20, 5, 'branco'),
      p('Lateral gaveta',           '15', v => v.P * 0.20, 10, 'branco'),
      p('Prateleira interna porta', '15', v => (v.C/3) * v.P, 2, 'branco'),
      p('Porta de giro',            '15', v => (v.C/3) * v.A, 1),
      p('Fundo do móvel',           '6',  v => v.C * v.A, 1),
      p('Fundo de gaveta',          '6',  v => (v.C - v.C/3) * v.P, 5),
    ],
    ferragens: { dobradica: 3, corredica: 5, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── CM-E — Cômoda Dupla 8 Gavetas ───────────────────────────────────────────
  'Cômoda Dupla 8 Gavetas': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',           '15', v => v.P * v.A, 2),
      p('Tampo',             '15', v => v.C * v.P, 1),
      p('Base',              '15', v => v.C * v.P, 1, 'branco'),
      p('Divisória vertical','15', v => v.P * v.A, 1, 'branco'),
      p('Frente gaveta',     '15', v => (v.C/2) * 0.20, 8),
      p('Traseira gaveta',   '15', v => (v.C/2) * 0.20, 8, 'branco'),
      p('Lateral gaveta',    '15', v => v.P * 0.20, 16, 'branco'),
      p('Fundo do móvel',    '6',  v => v.C * v.A, 1),
      p('Fundo de gaveta',   '6',  v => (v.C/2) * v.P, 8),
    ],
    ferragens: { dobradica: 0, corredica: 8, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── SAP-A — Sapateira Baixa 6 Nichos (aberta, 3×2) ──────────────────────────
  'Sapateira Baixa 6 Nichos': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',              '15', v => v.P * v.A, 2),
      p('Divisória vertical',   '15', v => v.P * v.A, 2),
      p('Tampo',                '15', v => v.C * v.P, 1),
      p('Base',                 '15', v => v.C * v.P, 1),
      p('Prateleira contínua',  '15', v => v.C * v.P, 1),
      p('Fundo',                '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 0, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── SAP-B — Sapateira Baixa 8 Nichos (4×2) ──────────────────────────────────
  'Sapateira Baixa 8 Nichos': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',              '15', v => v.P * v.A, 2),
      p('Divisória vertical',   '15', v => v.P * v.A, 3),
      p('Tampo',                '15', v => v.C * v.P, 1),
      p('Base',                 '15', v => v.C * v.P, 1),
      p('Prateleira contínua',  '15', v => v.C * v.P, 1),
      p('Fundo',                '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 0, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── SAP-C — Sapateira Baixa com 1 Porta + 4 Espaços ─────────────────────────
  'Sapateira Baixa 1 Porta': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',     '15', v => v.P * v.A, 2),
      p('Tampo',       '15', v => v.C * v.P, 1),
      p('Base',        '15', v => v.C * v.P, 1, 'branco'),
      p('Prateleira',  '15', v => v.C * v.P, 3, 'branco'),
      p('Porta de giro','15', v => v.C * v.A, 1),
      p('Fundo',       '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 3, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── SAP-D — Sapateira Baixa com 2 Portas + 4 Espaços ────────────────────────
  'Sapateira Baixa 2 Portas': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',     '15', v => v.P * v.A, 2),
      p('Tampo',       '15', v => v.C * v.P, 1),
      p('Base',        '15', v => v.C * v.P, 1, 'branco'),
      p('Prateleira',  '15', v => v.C * v.P, 3, 'branco'),
      p('Porta de giro','15', v => (v.C/2) * v.A, 2),
      p('Fundo',       '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 4, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── SAP-E — Sapateira Alta 1 Porta + 8 Espaços ──────────────────────────────
  'Sapateira Alta 1 Porta': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',     '15', v => v.P * v.A, 2),
      p('Tampo',       '15', v => v.C * v.P, 1),
      p('Base',        '15', v => v.C * v.P, 1, 'branco'),
      p('Prateleira',  '15', v => v.C * v.P, 7, 'branco'),
      p('Porta de giro','15', v => v.C * v.A, 1),
      p('Fundo',       '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 4, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── SAP-F — Sapateira Alta 2 Portas + 8 Espaços ─────────────────────────────
  'Sapateira Alta 2 Portas': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',     '15', v => v.P * v.A, 2),
      p('Tampo',       '15', v => v.C * v.P, 1),
      p('Base',        '15', v => v.C * v.P, 1, 'branco'),
      p('Prateleira',  '15', v => v.C * v.P, 7, 'branco'),
      p('Porta de giro','15', v => (v.C/2) * v.A, 2),
      p('Fundo',       '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 6, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── SAP-G — Sapateira Basculante 1 Porta (toda em 15mm) ────────────────────
  'Sapateira Basculante 1 Porta': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',          '15', v => v.P * v.A, 2),
      p('Tampo',            '15', v => v.C * v.P, 1),
      p('Base',             '15', v => v.C * v.P, 1, 'branco'),
      p('Porta basculante', '15', v => v.C * v.A, 1),
      p('Fundo',            '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 0, corredica: 0, pistao: 2, rodinha: 0, cabide: 0 },
  },

  // ── SAP-H — Sapateira Basculante 3 Portas (toda em 15mm) ───────────────────
  'Sapateira Basculante 3 Portas': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',                  '15', v => v.P * v.A, 2),
      p('Tampo',                    '15', v => v.C * v.P, 1),
      p('Base',                     '15', v => v.C * v.P, 1, 'branco'),
      p('Divisória horizontal',     '15', v => v.C * v.P, 2, 'branco'),
      p('Porta basculante',         '15', v => v.C * (v.A/3), 3),
      p('Fundo',                    '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 0, corredica: 0, pistao: 3, rodinha: 0, cabide: 0 },
  },

  // ── SAP-I — Sapateira Basculante Dupla 6 Portas (toda em 15mm) ─────────────
  'Sapateira Basculante Dupla 6 Portas': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',                  '15', v => v.P * v.A, 2),
      p('Divisória vertical',       '15', v => v.P * v.A, 1, 'branco'),
      p('Tampo',                    '15', v => v.C * v.P, 1),
      p('Base',                     '15', v => v.C * v.P, 1, 'branco'),
      p('Divisória horizontal',     '15', v => v.C * v.P, 2, 'branco'),
      p('Porta basculante',         '15', v => (v.C/2) * (v.A/3), 6),
      p('Fundo',                    '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 0, corredica: 0, pistao: 6, rodinha: 0, cabide: 0 },
  },

  // ── BAU-A — Baú sem Tampa ───────────────────────────────────────────────────
  'Baú sem Tampa': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',  '15', v => v.P * v.A, 2),
      p('Frente',   '15', v => v.C * v.A, 1),
      p('Traseira', '15', v => v.C * v.A, 1),
      p('Base',     '15', v => v.C * v.P, 1, 'branco'),
    ],
    ferragens: { dobradica: 0, corredica: 0, pistao: 0, rodinha: 4, cabide: 0 },
  },

  // ── BAU-B — Baú com Tampa ───────────────────────────────────────────────────
  'Baú com Tampa': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',  '15', v => v.P * v.A, 2),
      p('Frente',   '15', v => v.C * v.A, 1),
      p('Traseira', '15', v => v.C * v.A, 1),
      p('Base',     '15', v => v.C * v.P, 1, 'branco'),
      p('Tampa',    '15', v => v.C * v.P, 1),
    ],
    ferragens: { dobradica: 0, corredica: 0, pistao: 1, rodinha: 4, cabide: 0 },
  },

  // ── BAU-C — Baú Solteiro (= BAU-B com dimensões padrão solteiro) ────────────
  'Baú Solteiro': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',  '15', v => v.P * v.A, 2),
      p('Frente',   '15', v => v.C * v.A, 1),
      p('Traseira', '15', v => v.C * v.A, 1),
      p('Base',     '15', v => v.C * v.P, 1, 'branco'),
      p('Tampa',    '15', v => v.C * v.P, 1),
    ],
    ferragens: { dobradica: 0, corredica: 0, pistao: 1, rodinha: 4, cabide: 0 },
  },

  // ── BAU-D — Baú Casal (BAU-B + divisória vertical interna) ──────────────────
  'Baú Casal': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',                  '15', v => v.P * v.A, 2),
      p('Frente',                   '15', v => v.C * v.A, 1),
      p('Traseira',                 '15', v => v.C * v.A, 1),
      p('Base',                     '15', v => v.C * v.P, 1, 'branco'),
      p('Tampa',                    '15', v => v.C * v.P, 1),
      p('Divisória vertical interna','15', v => v.P * v.A, 1, 'branco'),
    ],
    ferragens: { dobradica: 0, corredica: 0, pistao: 2, rodinha: 4, cabide: 0 },
  },
}
